<template>
  <section class="category-menu category-menu__full" v-if="categories.length > 0">
    <div class="category-menu__wrap">
      <div class="category-menu__list-wrap">
        <ul class="category-menu__list">
          <li
            v-for="(item, index) in categories.items"
            class="category-menu__item"
          >
            <p
              @click="filterProducts(['Categoreis', item.name])"
              :class="{ active: selected['Categoreis'].includes(item.name) }"
              class="category-menu__link"
            >
              {{ item.name }} (<span class="category-menu__total">{{
                item.total
              }}</span
              >)
            </p>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "Categories",
  computed: {
    ...mapState("products", ["selected", "categories"]),
  },
  methods: {
    ...mapActions("products", ["filterProducts"]),
  },
};
</script>